export const MARKETPLACE_HOME_REQUESTED = "MARKETPLACE_HOME_REQUESTED";
export const MARKETPLACE_HOME_SUCCEEDED = "MARKETPLACE_HOME_SUCCEEDED";
export const MARKETPLACE_HOME_FAILED = "MARKETPLACE_HOME_FAILED";

export const MARKETPLACE_SEARCH_REQUESTED = "MARKETPLACE_SEARCH_REQUESTED";
export const MARKETPLACE_SEARCH_SUCCEEDED = "MARKETPLACE_SEARCH_SUCCEEDED";
export const MARKETPLACE_SEARCH_FAILED = "MARKETPLACE_SEARCH_FAILED";
export const MARKETPLACE_SEARCH_CLEARED = "MARKETPLACE_SEARCH_CLEARED";

export const MARKETPLACE_PRODUCTS_PAGE_REQUESTED = "MARKETPLACE_PRODUCTS_PAGE_REQUESTED";
export const MARKETPLACE_PRODUCTS_PAGE_SUCCEEDED = "MARKETPLACE_PRODUCTS_PAGE_SUCCEEDED";
export const MARKETPLACE_PRODUCTS_PAGE_FAILED = "MARKETPLACE_PRODUCTS_PAGE_FAILED";

export const MARKETPLACE_BRAND_PRODUCTS_REQUESTED = "MARKETPLACE_BRAND_PRODUCTS_REQUESTED";
export const MARKETPLACE_BRAND_PRODUCTS_SUCCEEDED = "MARKETPLACE_BRAND_PRODUCTS_SUCCEEDED";
export const MARKETPLACE_BRAND_PRODUCTS_FAILED = "MARKETPLACE_BRAND_PRODUCTS_FAILED";

export const PRODUCT_CREATE_REQUESTED = "PRODUCT_CREATE_REQUESTED";
export const PRODUCT_CREATE_SUCCEEDED = "PRODUCT_CREATE_SUCCEEDED";
export const PRODUCT_CREATE_FAILED = "PRODUCT_CREATE_FAILED";

export const PRODUCT_UPDATE_REQUESTED = "PRODUCT_UPDATE_REQUESTED";
export const PRODUCT_UPDATE_SUCCEEDED = "PRODUCT_UPDATE_SUCCEEDED";
export const PRODUCT_UPDATE_FAILED = "PRODUCT_UPDATE_FAILED";

export const PRODUCT_PATCH_REQUESTED = "PRODUCT_PATCH_REQUESTED";
export const PRODUCT_PATCH_SUCCEEDED = "PRODUCT_PATCH_SUCCEEDED";
export const PRODUCT_PATCH_FAILED = "PRODUCT_PATCH_FAILED";

export const PRODUCT_DELETE_REQUESTED = "PRODUCT_DELETE_REQUESTED";
export const PRODUCT_DELETE_SUCCEEDED = "PRODUCT_DELETE_SUCCEEDED";
export const PRODUCT_DELETE_FAILED = "PRODUCT_DELETE_FAILED";
